/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { EXPLORE_ROOM } from "../rooms/RoomNameConstants"
import {
    setChecked,
    setClue,
    setComparingData,
    setCurrentData,
    setManipulableSettings,
    setRange
} from "../store/slice/centerGraphSlice"
import store from "../store/store"
import { changeRoomHandler } from "./ChangeRoomHandlers"

const exploreRoomSetup = (
    compareTitle,
    range,
    checkedWorkstation,
) => {
    const state = store.getState()
    const currentRoom = state.room.history[0].ID
    const currentCenterGraphData = state.centerGraph.data

    const compare = { prev: currentRoom, compareTitle }

    store.dispatch(setComparingData(compare))
    store.dispatch(setCurrentData(currentCenterGraphData))
    store.dispatch(setRange(range))
    store.dispatch(setChecked(checkedWorkstation))
    store.dispatch(setManipulableSettings({
        VR: ['rotation', 'zoom', 'explore'],
        desktop: ['rotation', 'zoom']
    }))
}

export const handleGoToExploreRoom = (data) => {
    let compareTitle = "Workload on a selected workstation, in a time range";

    const checkedWorkstation = data?.zLabels?.map(() => true)
    const range = {
        from: data.xLabels ? data.xLabels[0] : [],
        to: data.xLabels ? data.xLabels[data.xLabels.length - 1] : []
    }

    changeRoomHandler(
        EXPLORE_ROOM,
        exploreRoomSetup(
            compareTitle,
            range,
            checkedWorkstation
        )
    )
}

export const resetExploreRoom = () => {
    const currentData = store.getState().centerGraph.currentData
    const isClueSaved = store.getState().centerGraph.position.clue?.isClueSaved

    // reset the filter applied to the center graph into explore room
    if (!!currentData) store.dispatch(setCurrentData(false))
    // check if we need to keep the red clue into the graph
    if (!isClueSaved) store.dispatch(setClue({}))

    store.dispatch(setManipulableSettings({
        VR: ['rotation', 'zoom', 'explore'],
        desktop: ['rotation']
    }))
}